module.exports = __webpack_public_path__ + "888a0bcc98c9093acd4f060ed0ffbe6f.pdf";